import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import api from "@/lib/api";
import { ReceiptToggle } from "@/components/testleads/TestReceipt";
import { DestinationTestHistory } from "./DestinationTestHistory";

const BTN = "border border-black px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white disabled:opacity-40";

// "Send test lead" for one delivery place, with the result, exactly what it received, and the last 5 test sends.
export function DestinationTestButton({ dest, firm }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [history, setHistory] = useState(null);
  const loadHistory = useCallback(() => {
    api.get(`/delivery/destinations/${dest.id}/test-sends`, { params: { limit: 5 } })
      .then(({ data }) => setHistory(data)).catch(() => setHistory(null));
  }, [dest.id]);
  useEffect(() => {
    loadHistory();
    window.addEventListener("delivery-alerts-changed", loadHistory);
    return () => window.removeEventListener("delivery-alerts-changed", loadHistory);
  }, [loadHistory]);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/delivery/destinations/${dest.id}/test`);
      setRes({ ...data, status: data.ok ? "delivered" : "failed", response_code: data.code });
      if (data.ok) toast.success(`Test lead delivered to ${dest.name}`);
      else toast.error(`Test lead didn't go through (${data.code})`);
      loadHistory();
    } catch (e) {
      toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Couldn't send the test");
    } finally { setBusy(false); }
  };
  return (
    <div className="w-full" data-testid={`dest-test-${dest.id}`}>
      <button type="button" className={BTN} onClick={run} disabled={busy} data-testid={`dest-test-btn-${dest.id}`}>
        <PaperPlaneTilt size={11} /> {busy ? "Sending…" : "Send test lead"}
      </button>
      {res && (
        <div className={`mt-2 border-2 p-2 text-[11px] ${res.ok ? "border-emerald-700 bg-emerald-50" : "border-red-700 bg-red-50"}`}
             data-testid={`dest-test-result-${dest.id}`} data-ok={res.ok ? "1" : "0"}>
          <b>{res.ok ? "Delivered" : "Not delivered"}</b> — response {res.code} · {res.fields_sent} fields sent · {new Date(res.created_at).toLocaleTimeString()}
          {res.response_body && <pre className="mt-1 max-h-24 overflow-auto whitespace-pre-wrap break-all bg-white/70 p-1 font-mono text-[10px]">{res.response_body}</pre>}
          <ReceiptToggle attempt={res} firm={firm} testId={`dest-test-receipt-${dest.id}`} />
        </div>
      )}
      <DestinationTestHistory destId={dest.id} history={history} firm={firm} onChanged={loadHistory} />
    </div>
  );
}
